import { lazy } from "react";

const PlannerMatching = lazy(() => import("../pages/planner/PlannerMatching"));
const PlannerMatchingResult = lazy(() => import("../pages/planner/PlannerMatchingResult"));
const PlannerList = lazy(() => import("../pages/planner/PlannerList"));
const PortfolioDetail = lazy(() => import("../pages/planner/PortfolioDetail"));
const AllPortfolioList = lazy(() => import("../pages/planner/AllPortfolioList"));

export const plannerRoutes = [
  { path: "/planner/matching/result", element: <PlannerMatchingResult /> },
  { path: "/planner/matching/:key", element: <PlannerMatching /> },
  { path: "/planners", element: <PlannerList /> },
  { path: "/planner/portfolio/:portfolioId", element: <PortfolioDetail /> },
  { path: "/planner/portfolios", element: <AllPortfolioList /> },
];